const Card = {
  parts: ['container', 'header', 'body', 'footer'],
  baseStyle: {
    container: {
      rounded: 'md',
      borderRadius: 'md',
      background: 'bgContent',
      padding: 4,
    },
  },
  variants: {
    borderless: {
      borderColor: 'transparent',
    },
  },
  defaultProps: {
    variant: 'borderless',
  },
}

export default Card
